import toString from 'lodash/toString';
import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductsApiService } from '@shared/services/products-api.service';
import { Store } from '@ngrx/store';
import {
  CART_DELIVERY_TYPES,
  CartServiceV2,
  CartState,
  DeliveryApiService,
  IUser,
  USER_ACCOUNT_TYPE
} from '@cakeiteasy/order-process';
import { BuildCakeBaseComponent } from '@shared/base-classes/build-cake-base.component';
import { ModalOpenerService } from '../modal-opener.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { EditingCakeSessionService } from '../../shared/services/editing-cake-session.service';
import { NavigationService } from '../../entire/services/navigation.service';
import { IBakeryCountry, MODAL} from '@cakeiteasy/web-utils';
import { AnalyticTracker } from '@analytic/services/analytic-tracker.service';
import { ISubmitBuilderPayload } from '@cakeiteasy/order-process/src/cake-builder/interfaces';

@Component({
  standalone: false,
  templateUrl: './build-cake-modal.component.html',
  styleUrls: ['./build-cake-modal.component.scss']
})
export class BuildCakeModalComponent extends BuildCakeBaseComponent implements OnInit {

  public typeId: number;
  public orderLineBuilderId: string;
  public user: IUser;
  public deliveryCheckerBusy: Promise<any>;

  public isSharedBusinessAccount: boolean;

  constructor(public modal: NgbActiveModal,
              public navigationService: NavigationService,
              deliveryApi: DeliveryApiService,
              componentResolver: ComponentFactoryResolver,
              modalOpener: ModalOpenerService,
              cartService: CartServiceV2,
              productsApiService: ProductsApiService,
              translate: TranslateService,
              toastr: ToastrService,
              store: Store<CartState>,
              editingCakeSession: EditingCakeSessionService,
              analyticTracker: AnalyticTracker,
  ) {
    super(
      deliveryApi,
      componentResolver,
      modalOpener,
      store,
      cartService,
      productsApiService,
      toastr,
      translate,
      analyticTracker,
      editingCakeSession,
      null
    );
  }

  public showDeliveryChecker(event: {
    deliveryType: CART_DELIVERY_TYPES,
    bakeryId: number,
    country: IBakeryCountry,
    productTypeId?: number,
  }): Promise<any> {
    const { deliveryType } = event;
    const { PICKUP } = CART_DELIVERY_TYPES;

    if (deliveryType === PICKUP) {
      return this.deliveryCheckerBusy = super.showDeliveryChecker(event);
    }

    return super.showDeliveryChecker(event);
  }

  public onCartBusy() {
    this.modal.dismiss();
  }

  public ngOnInit() {
    this._init();
  }

  public save(event: ISubmitBuilderPayload): Promise<any> {
    this.trackAddToCart(event);

    return super.save(event)
      .then((cart) => this._close(event))
      .catch((error) => {
        if (toString(error).indexOf(MODAL.CLOSE_EVENTS.DISMISSED) === -1) {
          this.cakeSavingError();
        }

        return Promise.reject(error);
      });
  }

  private _init() {
    if (this.user) {
      this.isSharedBusinessAccount = this.user.accountType === USER_ACCOUNT_TYPE.SHARED_BUSINESS_ACCOUNT;
    }

    this.loadCake(this.typeId, true, this.orderLineBuilderId)
      .catch(() => {
        // TODO review when new UI come
        this._toastr.error('Product is out of stock');
        this.modal.close();
      });
  }

  private _close($event) {
    setTimeout(
      () => {
        this.modal.close($event);
      });
  }
}
